import { Button, Grid } from "../../../../../components";
import {
  statusValidosConsulta,
  statusValidosBaixa,
  statusValidosDescarte,
  statusValidosRemessa,
} from "../../../resources/constantes";

const ButtonMenuBoleto = ({
  boletos,
  boletosSelecionados,
  consultarSituacao,
  imprimirBoletosLote,
  enviarMensagensLote,
  gerarRemessa,
  descarteEmLote,
  baixarEmLote,
  adicionarArquivoRetorno,
}) => {
  const validarStatus = (statusValidos) =>
    boletosSelecionados.length &&
    boletos
      .filter(({ id }) => boletosSelecionados.includes(id))
      .every((item) => statusValidos.includes(item.status));

  const validarIntegracao = () =>
    boletos
      .filter(({ id }) => boletosSelecionados.includes(id))
      .every(({ integradorId }) => !!integradorId?.length);

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="start"
      className="m-1 mx-3"
      gap={3}
    >
      <Button
        variant="contained"
        disabled={!validarStatus(statusValidosConsulta)}
        onClick={consultarSituacao}
      >
        <i
          className="ph-bold ph-barcode"
          style={{
            fontSize: 18,
            marginRight: 8,
            color: !validarStatus(statusValidosConsulta) ? "gray" : "white",
          }}
        ></i>
        Consultar Situação
      </Button>
      <Button
        variant="contained"
        disabled={!validarStatus(statusValidosConsulta)}
        onClick={imprimirBoletosLote}
      >
        <i
          className="ph-fill ph-printer"
          style={{
            fontSize: 18,
            marginRight: 8,
            color: !validarStatus(statusValidosConsulta) ? "gray" : "white",
          }}
        ></i>
        Impressão em Lote
      </Button>
      <Button
        variant="contained"
        disabled={!validarStatus(statusValidosConsulta)}
        onClick={enviarMensagensLote}
      >
        <i
          className={`ph-${
            !validarStatus(statusValidosConsulta) ? "bold" : "fill"
          } ph-whatsapp-logo`}
          style={{
            fontSize: 18,
            marginRight: 8,
            color: !validarStatus(statusValidosConsulta) ? "gray" : "white",
          }}
        ></i>
        Envio em Lote
      </Button>
      <Button
        variant="contained"
        disabled={!validarStatus(statusValidosRemessa)}
        onClick={gerarRemessa}
      >
        <i
          className="ph ph-file-arrow-down"
          style={{
            fontSize: 18,
            marginRight: 8,
            color: !validarStatus(statusValidosRemessa) ? "gray" : "white",
          }}
        ></i>
        Gerar Remessa
      </Button>
      <Button
        variant="contained"
        disabled={!validarStatus(statusValidosDescarte) || !validarIntegracao()}
        onClick={() => descarteEmLote(boletosSelecionados)}
      >
        <i
          className="ph-fill ph-trash"
          style={{
            fontSize: 18,
            marginRight: 8,
            color:
              !validarStatus(statusValidosDescarte) || !validarIntegracao()
                ? "gray"
                : "white",
          }}
        ></i>
        Cancelar Emissão
      </Button>
      <Button
        variant="contained"
        disabled={!validarStatus(statusValidosBaixa)}
        onClick={() => baixarEmLote(boletosSelecionados)}
      >
        <i
          className="ph ph-file-x"
          style={{
            fontSize: 18,
            marginRight: 8,
            color: !validarStatus(statusValidosBaixa) ? "gray" : "white",
          }}
        ></i>
        Cancelar Registro
      </Button>
      <Button variant="contained" onClick={adicionarArquivoRetorno}>
        <i
          className="ph ph-file-arrow-up"
          style={{
            fontSize: 18,
            marginRight: 8,
            color: "white",
          }}
        ></i>
        Processar Retorno
      </Button>
    </Grid>
  );
};

export default ButtonMenuBoleto;
